import React, { useState, useRef, useEffect } from 'react';
import './Autocomplete.scss';

export const Autocomplete = ({ suggestions, placeholder = 'Search...', onSelect ,value}) => {
  const [input, setInput] = useState(value ||'');
  const [filtered, setFiltered] = useState([]);
  const [activeIndex, setActiveIndex] = useState(0);
  const [showList, setShowList] = useState(false);

  const containerRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (containerRef.current && !containerRef.current.contains(event.target)) {
        setShowList(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);


  useEffect(() => {
    setInput(value || '');
  }, [value]);

  const handleChange = (e) => {
    const userInput = e.target.value;
    const filteredSuggestions = suggestions.filter((item) =>
      item.toLowerCase().includes(userInput.toLowerCase())
    );

    setInput(userInput);
    setFiltered(filteredSuggestions);
    setActiveIndex(0);
    setShowList(true);
  };

  const handleClick = (value) => {
    setInput(value);
    setFiltered([]);
    setShowList(false);
    onSelect && onSelect(value);
  };

  const handleKeyDown = (e) => {
    if (e.key === 'ArrowDown') {
      setActiveIndex((prev) => (prev + 1) % filtered.length);
    } else if (e.key === 'ArrowUp') {
      setActiveIndex((prev) => (prev - 1 + filtered.length) % filtered.length);
    } else if (e.key === 'Enter' && filtered.length > 0) {
      handleClick(filtered[activeIndex]);
    }
  };

  return (
    <div className="autocomplete" ref={containerRef}>
      <input
        type="text"
        placeholder={placeholder}
        value={input}
        onChange={handleChange}
        onKeyDown={handleKeyDown}
      />
      {showList && input && filtered.length > 0 && (
        <ul className="autocomplete-list">
          {filtered.map((item, index) => (
            <li
              key={item}
              className={index === activeIndex ? 'active' : ''}
              onClick={() => handleClick(item)}
            >
              {item}
            </li>
          ))}
        </ul>
      )}
    </div>
  );
};

